import LinkIcon from '@mui/icons-material/Link';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import Button from 'components/Button/Button';
import React, { useState } from 'react';
import { isUrl } from 'utils/index';

const useStyles = makeStyles((theme) => ({
  root: {},
  img: {
    width: 70,
    height: 50,
    objectFit: 'cover',
    marginRight: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  input: {},
}));

const ConnectLinkItem = ({ onClick, selected, data }) => {
  const classes = useStyles();
  const [showAdd, setShowAdd] = useState(false);
  const [values, setValue] = useState({
    overlay_text: data.overlay_text,
    redirect_url: data.redirect_url,
  });
  const [error, setError] = useState({
    overlay_text: false,
    redirect_url: false,
  });

  const handleSave = () => {
    const errors = {
      overlay_text: false,
      redirect_url: false,
    };
    if (!isUrl(values.redirect_url)) {
      errors.redirect_url = true;
    }
    if (!values.overlay_text) {
      errors.overlay_text = true;
    }
    if (!errors.overlay_text && !errors.redirect_url) {
      onClick({
        ...values,
        id: '0',
      });
      setShowAdd(false);
      setValue({
        overlay_text: '',
        redirect_url: '',
      });
    } else {
      setError(errors);
    }
  };

  const onChange = (event) => {
    setError({
      ...error,
      [event.target.name]: false,
    });
    const { name, value } = event.target;
    setValue({ ...values, [name]: value });
  };

  return (
    <Card
      variant="outlined"
      sx={{ mb: 1, borderColor: selected && 'primary.main' }}
    >
      <Box padding={1}>
        <Box display="flex" alignItems="center">
          {!showAdd && (
            <Box className={classes.img} bgcolor="#F7F8FC">
              <LinkIcon sx={{ color: '#894FE8' }} />
            </Box>
          )}
          <Box flex={1}>
            {showAdd ? (
              <Box>
                <TextField
                  fullWidth
                  autoFocus
                  required
                  size="small"
                  margin="dense"
                  variant="outlined"
                  placeholder="Link title"
                  name="overlay_text"
                  onChange={onChange}
                  value={values.overlay_text}
                  error={error.overlay_text}
                  helperText={error.overlay_text ? 'Required' : ''}
                />
                <TextField
                  fullWidth
                  required
                  size="small"
                  margin="dense"
                  variant="outlined"
                  placeholder="https://example.com"
                  name="redirect_url"
                  onChange={onChange}
                  value={values.redirect_url}
                  error={error.redirect_url}
                  helperText={
                    error.redirect_url ? 'Please enter a valid URL' : ''
                  }
                />
                <Box textAlign="right" mt={1}>
                  <Button
                    variant="text"
                    size="small"
                    onClick={() => setShowAdd()}
                  >
                    Cancel
                  </Button>{' '}
                  <Button size="small" onClick={handleSave}>
                    Save
                  </Button>
                </Box>
              </Box>
            ) : (
              <Typography>New Link</Typography>
            )}
          </Box>
          {!showAdd && (
            <Button
              onClick={() => setShowAdd(true)}
              variant="text"
              size="small"
            >
              {selected ? 'Added' : 'Add'}
            </Button>
          )}
        </Box>
      </Box>
    </Card>
  );
};

export default ConnectLinkItem;
